import { lock } from '@axo/shared/data-access/types';
import { IAPI } from '../../lib/models/api';

export function find({ url: { service }, token }: IAPI) {
  return async function (params: lock.FindRequest): Promise<lock.FindResult> {
    const url = new URL(`/lock/`, service);
    for (const [key, value] of Object.entries(params)) {
      url.searchParams.set(key, value);
    }

    const response = await fetch(url, {
      method: 'GET',
      mode: 'cors',
      headers: {
        Authorization: token,
      },
    });

    const responseJson = await response.json();

    if (response.ok) return responseJson;

    throw new Error(
      `Error fetching ${response.url}: ${response.status} ${
        response.statusText
      } ${responseJson.error || responseJson.message}`
    );
  };
}

export function createLock({ url: { service }, token }: IAPI) {
  return async function (id: string, clientID: string, marketCountry: string) {
    const params: Partial<lock.Lock> = {
      LoanApplicationID: id,
      LockedBy: clientID,
      Country: marketCountry,
    };
    const url = new URL(`/lock`, service);

    const response = await fetch(url, {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
      body: JSON.stringify(params),
    });

    if (response.status === 401) {
      return null;
    }

    const responseJson = await response.json();

    if (response.ok) return responseJson;

    throw new Error(
      `Error posting ${response.url}: ${response.status} ${
        response.statusText
      } ${responseJson.error || responseJson.message}`
    );
  };
}

export function unlock({ url: { service }, token }: IAPI) {
  return async function unlock(id: string): Promise<void> {
    const url = new URL(`/lock/${id}`, service);

    const response = await fetch(url, {
      method: 'DELETE',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
    });

    const responseJson = await response.json();

    if (response.ok) return responseJson;

    throw new Error(
      `Error deleting ${response.url}: ${response.status} ${
        response.statusText
      } ${responseJson.error || responseJson.message}`
    );
  };
}
